import React from 'react';
import PropTypes from 'prop-types';

const ConversionBannerText = ({ isFixedMatches, message }) => {
  if (isFixedMatches) {
    return null;
  }

  return <div className="ph3-ns ws-normal mb3 mb0-l mb3-s mv2-m">{message}</div>;
};

ConversionBannerText.propTypes = {
  isFixedMatches: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default ConversionBannerText;
